import { MEETING_CATEGORY_LIST_API_URL, MEETING_LIST_API_URL } from "../constants/urls";
import { FETCH_MEETING_CATEGORY_LIST, FETCH_MEETING_LIST, FETCH_MEETING_DETAILS } from "../constants/actionType";

function fetchMeetingCategoryList(url) {
    url = url && url.length > 0 ? url : MEETING_CATEGORY_LIST_API_URL;
    if (url) {
        return {
            type: FETCH_MEETING_CATEGORY_LIST,
            request: {
                url: url
            }
        };
    }
}
function fetchMeetingList(url) {
    url = url && url.length > 0 ? url : MEETING_LIST_API_URL;
    if (url) {
        return {
            type: FETCH_MEETING_LIST,
            request: {
                url: url
            }
        };
    }
}
function fetchMeetingDetailList(url) {
    if (url) {
        return {
            type: FETCH_MEETING_DETAILS,
            request: {
                url: url
            }
        };
    }
}
export {
    fetchMeetingCategoryList,
    fetchMeetingList,
    fetchMeetingDetailList
}
